import React, { useState, useEffect, useRef } from 'react';
import './old_Home.css';
import { Link } from 'react-router-dom';
import { collection, getDocs } from "firebase/firestore";
import { auth, db } from "../firebase";
import ModulePreviewModal from '../components/ModulePreviewModal';
import { FaArrowRight, FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from 'react-icons/fa6';
import { FaLightbulb } from 'react-icons/fa';
import FocusLoader from '../components/FocusLoader';

const Home = () => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedModule, setSelectedModule] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);


  // Estados para o chat
  const [messages, setMessages] = useState([
    { text: "Olá! Eu sou a Gama, sua assistente virtual. Estou aqui para ajudar você a explorar a Academia Gama. Como posso ajudar hoje?", sender: 'bot' },
    { text: "Você pode me perguntar sobre nossos módulos, como funciona a plataforma, ou como podemos ajudar em seu desenvolvimento pessoal e profissional.", sender: 'bot' }
  ]);
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);

  // Bot responses
  const botResponses = [
    "A Academia Gama oferece 6 módulos principais: Orientação Vocacional, Orientação Profissional, Oratória e Comunicação, Desenvolvimento Pessoal, Inteligência Emocional e Currículo Dinâmico.",
    "O seu perfil representa o seu currículo e, ele evolui junto com você, destacando suas novas habilidades e conquistas automaticamente. Assim que você cresça e a plataforma e sua comunidade tornam-se referências automaticamente",
    "Você pode experimentar qualquer módulo gratuitamente por 7 dias. Após esse período, escolha o plano que melhor atende às suas necessidades.",
    "Nosso currículo dinâmico se atualiza automaticamente conforme você adquire novas habilidades e realiza conquistas na plataforma.",
    "Sim, todos os nossos módulos são desenvolvidos por especialistas com ampla experiência em suas áreas de atuação.",
    "Você pode acessar a plataforma de qualquer dispositivo com conexão à internet: computador, tablet ou smartphone.",
    "Cada módulo tem duração média de 6 a 8 semanas, mas você pode avançar no seu próprio ritmo.",
    "Após completar um módulo, você recebe um certificado digital que pode ser compartilhado em suas redes profissionais."
  ];


  //Função para ver detalhes do módulo.
  const handleModuleClick = (module) => {
    setSelectedModule(module);
    setIsPreviewOpen(true);
  };

  // Função para rolar para o final das mensagens
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Mensagem automática após 3 segundos (apenas no início)
  useEffect(() => {
    const timer = setTimeout(() => {
      setMessages(prev => [...prev, { text: "Estou aqui para responder suas dúvidas sobre a Academia Gama! O que gostaria de saber?", sender: 'bot' }]);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // Enviar mensagem
  const sendMessage = () => {
    if (inputValue.trim() === '') return;

    // Adiciona mensagem do usuário
    const newMessage = { text: inputValue, sender: 'user' };
    setMessages(prev => [...prev, newMessage]);
    setInputValue('');

    // Simula resposta do bot após 1 segundo
    setTimeout(() => {
      const randomResponse = botResponses[Math.floor(Math.random() * botResponses.length)];
      setMessages(prev => [...prev, { text: randomResponse, sender: 'bot' }]);
    }, 1000);
  };

  // Função para lidar com a tecla Enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };


  useEffect(() => {
    async function fetchModules() {
      try {
        const snap = await getDocs(collection(db, "modules"));
        const list = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setModules(list);
      } catch (err) {
        console.error("Erro ao carregar módulos:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchModules();
  }, []);


  if (loading) return <FocusLoader />;
  //if (modules.length === 0) return <p>Não há módulos disponíveis.</p>;

  return (
    <>
      <div className="home">
        {/* Header */}
        <header>
          <div className="container">
            <div className="header-content">
              <div className="logo">
                <div className="logo-icon">
                  <img src="/logo.jpg" className='w-10 h-10' alt="Logotipo Academia Gama" />
                </div>
                <h1>Academia <span>Gama</span></h1>
              </div>
              <nav>
                <ul>
                  <li><a href="#home">Início</a></li>
                  <li><a href="#chat">Experimente</a></li>
                  <li><a href="#modules">Módulos</a></li>
                  <li><a href="#oportunitor">Oportunitor</a></li>
                  <li><a href="#testimonials">Depoimentos</a></li>
                  <li><a href="#contact">Contato</a></li>
                </ul>
              </nav>
              {auth.currentUser != null ?
                <Link to={'dashboard'} className="cta-button">Meu Perfil</Link>
                :
                <Link to={'login'} className="cta-button">Entrar</Link>
              }
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="hero" id="home">
          <div className="container">
            <div className="hero-content">
              <h1>Transforme sua carreira e sua vida emocional</h1>
              <p>Descubra seu potencial, desenvolva habilidades essenciais e conquiste equilíbrio emocional com nossa plataforma de desenvolvimento humano e inteligência emocional.</p>
              <div className="hero-buttons">
                <button className="cta-button">Comece Agora</button>
                <button className="secondary-button">Saiba Mais</button>
              </div>
            </div>
          </div>
        </section>

        {/* Chat Section */}
        <section className="chat-section" id="chat">
          <div className="container">
            <div className="section-title">
              <h2>Experimente nossa plataforma</h2>
              <p>Converse com nosso assistente virtual e descubra como podemos ajudar em sua jornada de desenvolvimento pessoal e profissional</p>
            </div>
            <div className="chat-container">
              <div className="chat-wrapper">
                <div className="chat-header">
                  <i className="fas fa-comments"></i>
                  <h3>Assistente Virtual Gama</h3>
                </div>
                <div className="chat-messages" id="chat-messages">
                  {messages.map((message, index) => (
                    <div key={index} className={`message ${message.sender === 'bot' ? 'bot-message' : 'user-message'}`}>
                      {message.text}
                    </div>
                  ))}
                  <div ref={messagesEndRef} />
                </div>
                <div className="chat-input">
                  <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Digite sua mensagem..."
                  />
                  <button onClick={sendMessage}><i className="fas fa-paper-plane"></i></button>
                </div>
              </div>
              <div className="chat-visual">
                <div className="visual-element">
                  <FaLightbulb />
                  <h3>Sua jornada começa aqui</h3>
                  <p>Converse com nosso assistente e descubra o módulo ideal para seu desenvolvimento pessoal e profissional</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Modules Section */}
        <section className="modules-section" id="modules">
          <div className="container">
            <div className="section-title">
              <h2>Nossos Módulos de Desenvolvimento</h2>
              <p>Explore nossas áreas de especialização e encontre o caminho ideal para seu crescimento pessoal e profissional</p>
            </div>
            <div className="modules-grid">
              {/* Module 1 */}
              <div className="module-card">
                <div className="module-header" style={{ background: 'linear-gradient(135deg, #6a89cc, #4a69bd)' }}>
                  <h3>Orientação Vocacional</h3>
                  <div className="module-icon" style={{ color: '#6a89cc' }}>
                    <i className="fas fa-user-graduate"></i>
                  </div>
                </div>
                <div className="module-content flex flex-col">
                  <p>Descubra quem você é, suas aptidões e escolha sua carreira ideal com base em seus talentos e paixões.</p>
                  <button onClick={() => handleModuleClick(modules[5])} className="module-button"> <span>Saiba mais</span>  <FaArrowRight /></button>
                </div>
              </div>

              {/* Module 2 */}
              <div className="module-card">
                <div className="module-header" style={{ background: 'linear-gradient(135deg, #f6b93b, #e55039)' }}>
                  <h3>Orientação Profissional</h3>
                  <div className="module-icon" style={{ color: '#f6b93b' }}>
                    <i className="fas fa-briefcase"></i>
                  </div>
                </div>
                <div className="module-content flex flex-col">
                  <p>Encontre um trabalho ou planeje sua trajetória no mercado de trabalho com estratégias comprovadas.</p>
                  <button onClick={() => handleModuleClick(modules[4])} className="module-button"> <span>Saiba mais</span>  <FaArrowRight /></button>
                </div>
              </div>

              {/* Module 3 */}
              <div className="module-card">
                <div className="module-header" style={{ background: 'linear-gradient(135deg, #1dd1a1, #10ac84)' }}>
                  <h3>Oratória e Comunicação</h3>
                  <div className="module-icon" style={{ color: '#1dd1a1' }}>
                    <i className="fas fa-comment-dots"></i>
                  </div>
                </div>
                <div className="module-content flex flex-col">
                  <p>Aprimore suas habilidades de fala e expressão para se comunicar com confiança em qualquer situação.</p>
                  <button onClick={() => handleModuleClick(modules[3])} className="module-button"> <span>Saiba mais</span>  <FaArrowRight /></button>
                </div>
              </div>

              {/* Module 4 */}
              <div className="module-card">
                <div className="module-header" style={{ background: 'linear-gradient(135deg, #9b59b6, #8e44ad)' }}>
                  <h3>Desenvolvimento Pessoal</h3>
                  <div className="module-icon" style={{ color: '#9b59b6' }}>
                    <i className="fas fa-user-astronaut"></i>
                  </div>
                </div>
                <div className="module-content flex flex-col">
                  <p>Cresça em autoconhecimento e desenvolva hábitos saudáveis para uma vida mais plena e realizada.</p>
                  <button onClick={() => handleModuleClick(modules[1])} className="module-button"> <span>Saiba mais</span>  <FaArrowRight /></button>
                </div>
              </div>

              {/* Module 5 */}
              <div className="module-card">
                <div className="module-header" style={{ background: 'linear-gradient(135deg, #48dbfb, #0abde3)' }}>
                  <h3>Inteligência Emocional</h3>
                  <div className="module-icon" style={{ color: '#48dbfb' }}>
                    <i className="fas fa-brain"></i>
                  </div>
                </div>
                <div className="module-content flex flex-col">
                  <p>Gerencie suas emoções de forma eficaz e construa relacionamentos mais saudáveis e significativos.</p>
                  <button onClick={() => handleModuleClick(modules[2])} className="module-button"> <span>Saiba mais</span>  <FaArrowRight /></button>
                </div>
              </div>

              {/* Module 6 */}
              <div className="module-card">
                <div className="module-header" style={{ background: 'linear-gradient(135deg, #ff9ff3, #f368e0)' }}>
                  <h3>Construtor de Habilidades</h3>
                  <div className="module-icon" style={{ color: '#ff9ff3' }}>
                    <i className="fas fa-file-alt"></i>
                  </div>
                </div>
                <div className="module-content flex flex-col">
                  <p>Aqui você pode desenvolver qualquer habilidade que você quiser no menor tempo possícel, você terá acompanhamento especializado além de suporte da Inteligência Artificial para acelerar o aprendizado.</p>
                  <button onClick={() => handleModuleClick(modules[0])} className="module-button"> <span>Saiba mais</span>  <FaArrowRight /></button>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* Oportunitor Section */}
        <section className="cta-section" id='oportunitor'>
          <div className="container">
            <h2>Procura oportunidades de trabalho ou formação?</h2>
            <p>O Oportunitor ajuda-te a <strong>encontrar oportunidades de emprego </strong> alinhadas ao teu perfil ou <strong>ajudá-te a ajustar o seu perfil para corresponder com qualquer oportunidade disponível</strong>. Este é o portal para a realização do teu sonho, vá em frente acesse agora é gratuito.</p>

            <button className="cta-button text-3xl">Acessar <strong>OPORTUNITOR</strong> gratuitamente</button>

          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section" id="testimonials">
          <div className="container">
            <div className="section-title">
              <h2>O que dizem nossos usuários</h2>
              <p>Histórias reais de transformação e crescimento através da Academia Gama</p>
            </div>
            <div className="testimonials-container">
              {/* Testimonial 1 */}
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-avatar">A</div>
                  <div className="testimonial-info">
                    <h4>Ana Carolina</h4>
                    <p>Psicóloga</p>
                    <div className="rating">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <p>"A Academia Gama transformou minha abordagem profissional. O módulo de Inteligência Emocional me deu ferramentas que aplico diariamente com meus pacientes."</p>
              </div>

              {/* Testimonial 2 */}
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-avatar">R</div>
                  <div className="testimonial-info">
                    <h4>Ricardo Mendes</h4>
                    <p>Engenheiro</p>
                    <div className="rating">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <p>"A orientação profissional me ajudou a fazer uma transição de carreira que eu temia há anos. Hoje trabalho com o que amo e ganho mais!"</p>
              </div>

              {/* Testimonial 3 */}
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-avatar">M</div>
                  <div className="testimonial-info">
                    <h4>Mariana Torres</h4>
                    <p>Estudante Universitária</p>
                    <div className="rating">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star-half-alt"></i>
                    </div>
                  </div>
                </div>
                <p>"O módulo de oratória mudou minha vida acadêmica. Antes tremia ao apresentar trabalhos, hoje falo com confiança para plateias de 100+ pessoas!"</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <h2>Pronto para transformar sua vida?</h2>
            <p>Junte-se a milhares de pessoas que já estão transformando suas carreiras e vidas emocionais com a Academia Gama</p>
            <button className="cta-button">Comece Agora Gratuitamente</button>
          </div>
        </section>

        {/* Footer */}
        <footer id="contact">
          <div className="container">
            <div className="footer-content">
              <div className="footer-column">
                <h3>Academia Gama</h3>
                <p>Sua plataforma completa para desenvolvimento humano, orientação profissional e inteligência emocional.</p>
                <div className="social-links">
                  <a href="/#"><FaTiktok /></a>
                  <a href="/#"><FaFacebook /></a>
                  <a href="/#"><FaInstagram className="fab fa-instagram" /></a>
                  <a href="/#"><FaLinkedin className="fab fa-linkedin-in" /></a>
                  <a href="/#"><FaYoutube className="fab fa-youtube" /></a>
                </div>
              </div>

              <div className="footer-column">
                <h3>Módulos</h3>
                <ul className="footer-links">
                  <li><a href="/#">Orientação Vocacional</a></li>
                  <li><a href="/#">Orientação Profissional</a></li>
                  <li><a href="/#">Oratória e Comunicação</a></li>
                  <li><a href="/#">Desenvolvimento Pessoal</a></li>
                  <li><a href="/#">Inteligência Emocional</a></li>
                </ul>
              </div>

              <div className="footer-column">
                <h3>Links Rápidos</h3>
                <ul className="footer-links">
                  <li><a href="/#">Sobre Nós</a></li>
                  <li><a href="/#">Blog</a></li>
                  <li><a href="/#">Carreiras</a></li>
                  <li><a href="/#">Contato</a></li>
                  <li><a href="/#">Política de Privacidade</a></li>
                </ul>
              </div>

              <div className="footer-column">
                <h3>Contato</h3>
                <ul className="footer-links">
                  <li><i className="fas fa-envelope"></i> timoteodagama93@gmail.com</li>
                  <li><i className="fas fa-phone"></i> (+244) 927 678 173</li>
                  <li><i className="fas fa-map-marker-alt"></i> Ngola Kiluange, Luanda, Angola</li>
                </ul>
              </div>
            </div>
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} Academia Gama. Todos os direitos reservados.</p>
            </div>
          </div>
        </footer>
        <ModulePreviewModal
          module={selectedModule}
          isOpen={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
        />
      </div>
    </>
  );
};

export default Home;